(function(){
  if(window.__moscouPairBound)return;
  window.__moscouPairBound=true;
  document.addEventListener('change',function(event){
    if(!event.target.matches('.moscou-pair select'))return;
    var root=event.target.closest('.moscou-pair');
    var option=event.target.selectedOptions[0];
    var price=root.querySelector('.moscou-pair__price');
    price.querySelector('s').textContent=option.dataset.before;
    price.querySelector('strong').textContent=option.dataset.total;
    price.querySelector('.moscou-pair__save').textContent='Economize '+option.dataset.save;
  });
  document.addEventListener('click',async function(event){
    var button=event.target.closest('.moscou-pair__button');
    if(!button)return;
    var root=button.closest('.moscou-pair');
    var select=root.querySelector('select');
    button.disabled=true;
    button.textContent='Adicionando...';
    try{
      var drawer=document.querySelector('cart-drawer');
      if(!drawer || typeof drawer.renderContents!=='function')throw new Error('cart drawer unavailable');
      var sections=drawer.getSectionsToRender().map(function(section){return section.id});
      var response=await fetch('/cart/add.js',{
        method:'POST',
        headers:{'Content-Type':'application/json','Accept':'application/json'},
        body:JSON.stringify({items:[
          {id:Number(select.value),quantity:1},
          {id:Number(root.dataset.chair),quantity:1}
        ],sections:sections,sections_url:window.location.pathname})
      });
      if(!response.ok)throw new Error('cart add failed');
      var state=await response.json();
      if(!state.sections || !state.sections['cart-drawer'])throw new Error('cart sections unavailable');
      drawer.renderContents(state);
      button.disabled=false;
      button.textContent='Adicionar sofá + poltrona ao carrinho';
    }catch(error){
      button.disabled=false;
      button.textContent='Adicionar sofá + poltrona ao carrinho';
      alert('Não foi possível adicionar o conjunto. Tente novamente.');
    }
  });
})();
